<ng-content></ng-content>
@if (postfix()) {
  <span #postfixElement class="pointer-events-none absolute inset-y-0 end-0 flex items-center px-2 ps-3.5 text-support">
    {{ postfix() }}
  </span>
}
